const numberToFormattedString = (value, prefix, language) =>
  `${prefix} ${value.toLocaleString(language, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export default numberToFormattedString;
